import type { HtmlDataConfig } from '@/types';

const htmlData = {
  metaDescription:
    'Lohnt ein Einspruch gegen den Bu&szlig;geldbescheid? Prüfen Sie jetzt unverbindlich Ihre Möglichkeiten auf bussgeldcheck.wbs.legal!',
  domainName: 'bussgeldcheck.wbs.legal',
  trackJsToken: '62fe293f90284011bb0b964f50fb0872',
  trackJsApplicationName: 'wbs-bussgeldcheck',
  funnelType: '',
  htmlTitle: 'Bußgeldcheck - präsentiert von SOS-Verkehrsrecht.de',
  gtmContainerId: 'WSPK2J3F',
  cmpId: '7bd4de2a31080',
  seo: '<div>Lohnt ein Einspruch gegen den Bußgeldbescheid? Prüfen Sie jetzt unverbindlich Ihre Möglichkeiten auf bussgeldcheck.wbs.legal!</div>',
  convertProjectId: '',
} satisfies HtmlDataConfig as HtmlDataConfig;

export default htmlData;
